import type { Point } from '../types/point.type';
import type { Viewport } from '../types/viewport.type';

export const isPointContained = (
  current: Point,
  container: Viewport,
): boolean => {
  const [curLon, curLat] = current;
  const [refMinLon, refMinLat, refMaxLon, refMaxLat] = container;

  return (
    curLon >= refMinLon &&
    curLat >= refMinLat &&
    curLon <= refMaxLon &&
    curLat <= refMaxLat
  );
};
